export const RETRY_ERROR_CODES = [500, 501, 502, 503, 504, 512, 514] as const
export const MAX_RETRIES = 3
export const RETRY_INTERVAL = 400 // ms
